export const NUMBER_OF_PREDEFINED_GRADIENTS = 12;
